export { type SocialLinksProps, default as SocialLinks } from './SocialLinks';
